// export const pageview = () => {
//   window.fbq && window.fbq("track", "PageView");
// };

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export const event = (name, options = {}, event) => {
  window.fbq && window.fbq("track", name, options, event ?? undefined);
};

export const tiktokEvent = (name, options = {}) => {
  if (window.ttq && typeof window.ttq.track === "function") {
    window.ttq.track(name, options);
  } else {
    console.warn("TikTok Pixel not initialized");
  }
};
